import { reduxStoreTypes } from '@/type/redux-store';


export const SET_BLACK_SYSTEMS: reduxStoreTypes.BlackSystemsType = 'SET_BLACK_SYSTEMS';
export const setBlackSystems = (params: Omit<reduxStoreTypes.BlackSystemsAction, 'type'>) => ({
    type: SET_BLACK_SYSTEMS,
    ...params
})